export enum BroadCastEvents {
  ClinicChanged = "ClinicChanged",
  UserClinicChanged = "UserClinicChanged",
  InsurancePlanContactPersonChanged = "InsurancePlanContactPersonChanged",
  TranslationsChanged = "TranslationsChanged",
  ProviderClinicChanged = "ProviderClinicChanged",
  NoteChanged = "NoteChanged",
  InsuranceChanged = "InsuranceChanged",
  InsuranceSubscriberChanged = "InsuranceSubscriberChanged",
  InsuranceSubscriberSelected = "InsuranceSubscriberSelected",
  AppointmentChanged = "AppointmentChanged",
  AppointmentSelected = "AppointmentSelected",
  UnavailableSlotChanged = "UnavailableSlotChanged",
  ProductChanged = "ProductChanged",
  ProductSelected = "ProductSelected",
  ProductStyleSelected = "ProductStyleSelected",
  RelatedCompanionChanged = "RelatedCompanionChanged",
  PriceListProductChanged = "PriceListProductChanged",
  PriceListProductStyleChanged = "PriceListProductStyleChanged",
  PriceListInsurancePlanChanged = "PriceListInsurancePlanChanged",
  SerializedItemChanged = "SerializedItemChanged",
  SalesOrderChanged = "SalesOrderChanged",
  AddSalesOrderLineProductStyleSelected = "AddSalesOrderLineProductStyleSelected",
  EquipmentProductStyleSelected = "EquipmentProductStyleSelected",
  CustomizeLineSerialNumberChanged = "CustomizeLineSerialNumberChanged",
  PriceListInsurancePlanBenefitChanged = "PriceListInsurancePlanBenefitChanged",
  UserChanged = "UserChanged",
  PatientReferringPhysicianChanged = "PatientReferringPhysicianChanged",
  ReferringPhysicianChanged = "ReferringPhysicianChanged",
  PatientClinicProviderChanged = "PatientClinicProviderChanged",
  SalesOrderLineChanged = "SalesOrderLineChanged",
  SalesOrderStatusChanged = "SalesOrderStatusChanged",
  SalesOrderLinesStatusChanged = "SalesOrderLinesStatusChanged",
  PatientDocumentChanged = "PatientDocumentChanged",
  PatientChanged = "PatientChanged",
  PatientPhotoChanged = "PatientPhotoChanged",
  PatientAlertChanged = "PatientAlertChanged",
  PatientSelected = "PatientSelected",
  PriceListProductStylesOptionsDetailsUpdated = "PriceListProductStylesOptionsDetailsUpdated",
  ProductStyleChanged = "ProductStyleChanged",
  MultipleProductStylesCreated = "MultipleProductStylesCreated",
  MedicalReportChanged = "MedicalReportChanged",
  AppointmentHaNeededChanged = "AppointmentHaNeededChanged",
  AppointmentRecommendationChanged = "AppointmentRecommendationChanged",
  PriceListInsurancePlansOptionsDetailsUpdated = "PriceListInsurancePlansOptionsDetailsUpdated",
  WaitListChanged = "WaitListChanged",
  AppointmentRequestChanged = "AppointmentRequestChanged",
  RecallChanged = "RecallChanged",
  SchedulerRefresh = "SchedulerRefresh",
  AuthorizationAdded = "AuthorizationAdded",
  AuthorizationUpdated = "AuthorizationUpdated",
  InsuranceTransactionPaymentChanged = "InsuranceTransactionPaymentChanged",
  PaymentChanged = "PaymentChanged",
  PaymentResynced = "PaymentResynced",
  SalesOrderPendingWorkflow = "SalesOrderPendingWorkflow",
  ProductKitChanged = "ProductKitChanged",
  ProductBundleChanged = "ProductBundleChanged",
  MarketingListMemberAdded = "MarketingListMemberAdded",
  ClaimUpdated = "ClaimUpdated",
  ClaimCreated = "ClaimCreated",
  ProviderCertificationChanged = "ProviderCertificationChanged",
  InventoryAuditProductsChanged = "InventoryAuditProductsChanged",
  InsurancePlanProductModifierChanged = "InsurancePlanProductModifierChanged",
  NoahSessionUpdated = "NoahSessionUpdated",
  CampaignDocumentTemplateChanged = "CampaignDocumentTemplateChanged",
  ProviderLicenseChanged = "ProviderLicenseChanged",
  InventoryThresholdProductsChanged = "InventoryThresholdProductsChanged",
  SalesOrderPaymentPlanChanged = "SalesOrderPaymentPlanChanged",
  PaymentPlanDepositChanged = "PaymentPlanDepositChanged",
  SchedulerReschedule = "SchedulerReschedule",
  CountryStateSetupChanged = "CountryStateSetupChanged",
  ClinicLogoChanged = "ClinicLogoChanged",
  TaxesChanged = "TaxesChanged",
  SalesOrderDiagnosisChanged = "SalesOrderDiagnosisChanged",
  ProviderAcademicDegreeChanged = "ProviderAcademicDegreeChanged",
  CompanyChanged = "CompanyChanged",
  CompanyLogoChanged = "CompanyLogoChanged",
  CampaignMembersAdded = "CampaignMembersAdded",
  FinancingTypeChanged = "FinancingTypeChanged",
  DocumentTemplateChanged = "DocumentTemplateChanged",
  BrandChanged = "BrandChanged",
  BrandLogoChanged = "BrandLogoChanged",
  RegionReferralSourceChanged = "RegionReferralSourceChanged",
  MarketingCampaignClinicChanged = "MarketingCampaignClinicChanged",
  MarketingCampaignRegionChanged = "MarketingCampaignRegionChanged",
  MarketingCampaignChanged = "MarketingCampaignChanged",
  ResourceClinicChanged = "ResourceClinicChanged",
  ApiKeyCreated = "ApiKeyCreated",
  HANeedRuleCreated = "HANeedRuleCreated",
  SamlEndpointChanged = "SamlEndpointChanged",
  ScheduleTemplateSlotChanged = "ScheduleTemplateSlotChanged",
  ScheduleTemplateUnavailableSlotChanged = "ScheduleTemplateUnavailableSlotChanged",
  ScheduleTemplateApplicationChanged = "ScheduleTemplateApplicationChanged",
  DispensingFeeChanged = "DispensingFeeChanged",
  SchedulingWidgetHostChanged = "SchedulingWidgetHostChanged",
  StateChanged = "StateChanged",
  NetworkProviderSiteAndLicenseChanged = "NetworkProviderSiteAndLicenseChanged",
  PatientStatusChanged = "PatientStatusChanged",
  NetworkProviderSelected = "NetworkProviderSelected",
  ReferralSourceRegionMarketingCampaignChanged = "ReferralSourceRegionMarketingCampaignChanged",
  InventoryOrderCreated = "InventoryOrderCreated",
  InventoryOrderSelected = "InventoryOrderSelected",
  WorkQueueNotesFilterChanged = "WorkQueueNotesFilterChanged",
  WorkQueueNotesLoaded = "WorkQueueNotesLoaded",
  ClinicObonoRenewed = "ClinicObonoRenewed",
  BrandDocumentChanged = "BrandDocumentChanged",
  InsurancePlanSelected = "InsurancePlanSelected",
  LegacySalesOrderChanged = "LegacySalesOrderChanged",
  LegacyProductStyleSelected = "LegacyProductStyleSelected",
  LegacyAddSalesOrderLineProductStyleSelected = "LegacyAddSalesOrderLineProductStyleSelected",
  LegacySalesOrderLineChanged = "LegacySalesOrderLineChanged",
  LegacySalesOrderStatusChanged = "LegacySalesOrderStatusChanged",
  LegacySalesOrderLinesStatusChanged = "LegacySalesOrderLinesStatusChanged",
  ManufacturerColorChanged = "ManufacturerColorChanged",
  ProductStyleColorChanged = "ProductStyleColorChanged",
  ProductStyleProductOptionChanged = "ProductStyleProductOptionChanged",
  AddLegacySalesOrderLineProductStyleSelected = "AddLegacySalesOrderLineProductStyleSelected",
  MapItemMasterToProduct = "MapItemMasterToProduct",
  ProductCatalogModalClosed = "ProductCatalogModalClosed",
  ProductOptionChanged = "ProductOptionChanged",
  ProviderEnrollmentInsurancePlanChanged = "ProviderEnrollmentInsurancePlanChanged",
  PatientEquipmentChanged = "PatientEquipmentChanged",
  AppointmentTouched = "AppointmentTouched",
  ValidateBenefitChanged = "ValidateBenefitChanged",
  ServerErrorOccurred = "ServerErrorOccurred",
  WorkQueueTouched= "WorkQueueTouched",
  ServicePlanBenefitChanged = "ServicePlanBenefitChanged",
  ServicePlanChanged = "ServicePlanChanged",
  PatientServicePlanChanged = "PatientServicePlanChanged",
  ServicePlanProductStyleChanged = "ServicePlanProductStyleChanged",
  InsuranceContractSelected = "InsuranceContractSelected",
  ProviderEnrollmentChanged = "ProviderEnrollmentChanged",
  BillingEntityMappingChanged = "BillingEntityMappingChanged",
  ShowNotification = "ShowNotification",
  SqlTaskExecuted = "SqlTaskExecuted",
  InventoryTranferred = "InventoryTransferred",
}
